import { Link } from "react-router-dom";
import { CONTENT } from "@/content";
import { Ripple } from "@/components/Ripple";
import { StoryJourney } from "@/components/home/StoryJourney";
import { WordOfDay } from "@/components/home/WordOfDay";
import { Situations } from "@/components/home/Situations";
import { SharePurpose } from "@/components/home/SharePurpose";
import { HowItWorks } from "@/components/home/HowItWorks";

const { hero, cta } = CONTENT.home;

export default function Home() {
  return (
    <main className="page" data-testid="home-page">
      <section className="hero" data-testid="home-hero">
        <div className="hero-content">
          <span className="origin" aria-hidden="true">
            <Ripple />
            <span className="origin-dot" />
          </span>
          <h1 className="hero-title" data-testid="hero-headline">{hero.headline}</h1>
          <p className="hero-sub" data-testid="hero-supporting-line">{hero.supporting}</p>
          <div className="hero-actions">
            {hero.buttons.map((b, i) => (
              <Link key={b.to} to={b.to} className={`nb-btn ${b.style === "ghost" ? "ghost" : ""}`} data-testid={`hero-button-${i + 1}`}>{b.label}</Link>
            ))}
          </div>
        </div>
      </section>

      <div className="blocks">
        <WordOfDay />
        <Situations />
        <StoryJourney />
        <SharePurpose />
        <HowItWorks />

        <section className="nb-card cta-card" data-testid="home-cta-card">
          <p className="cta-line" data-testid="cta-line">{cta.line}</p>
          <Link to={cta.buttonTo} className="nb-btn" data-testid="open-library-button">{cta.buttonLabel}</Link>
        </section>
      </div>
    </main>
  );
}
